import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PaceCoreModule } from '@evorait/pace-core';
import { DetailsModule } from '../details/details.module';
import { SharedModule } from '../shared/shared.module';
import { ConfirmationComplaintsP58Component } from './confirmation-complaints-p58/confirmation-complaints-p58.component';
import { ConfirmationEquipmentComponent } from './confirmation-equipment/confirmation-equipment.component';
import { ConfirmationExpensesComponent } from './confirmation-expenses/confirmation-expenses.component';
import { ConfirmationFollowupComponent } from './confirmation-followup/confirmation-followup.component';
import { ConfirmationAddMaterialComponent } from './confirmation-material-consume/confirmation-add-material/confirmation-add-material.component';
import { ConfirmationMaterialConsumeComponent } from './confirmation-material-consume/confirmation-material-consume.component';
import { ConfirmationMaterialGoodsInfoComponent } from './confirmation-material-consume/confirmation-material-goods-info/confirmation-material-goods-info.component';
import { ConfirmationMaterialStockComponent } from './confirmation-material-consume/confirmation-material-stock/confirmation-material-stock.component';
import { MaterialConsumptionRowComponent } from './confirmation-material-consume/material-consumption-row/material-consumption-row.component';
import { ConfirmationMeasurementToolsComponent } from './confirmation-measurement-tools/confirmation-measurement-tools.component';
import { ConfirmationMeasuringPointsComponent } from './confirmation-measuring-points/confirmation-measuring-points.component';
import { ConfirmationParticipantsComponent } from './confirmation-participants/confirmation-participants.component';
import { ConfirmationServiceReportComponent } from './confirmation-service-report/confirmation-service-report.component';
import { ConfirmationSignatureComponent } from './confirmation-summary/confirmation-signature/confirmation-signature.component';
import { ConfirmationSummaryComponent } from './confirmation-summary/confirmation-summary.component';
import { AddTimeRecordingEntryFormComponent } from './confirmation-time-recording/add-time-recording-entry-form/add-time-recording-entry-form.component';
import { ConfirmationTimeRecordingComponent } from './confirmation-time-recording/confirmation-time-recording.component';
import { ConfirmationUploadToDocboxComponent } from './confirmation-upload-to-docbox/confirmation-upload-to-docbox.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { TimeSheetEntriesComponent } from './confirmation-time-recording/time-sheet-entries/time-sheet-entries.component';
import { ConfirmationSummaryMaterialComponent } from './confirmation-summary/confirmation-summary-material/confirmation-summary-material.component';
import { ConfirmationSummaryParticipantsComponent } from './confirmation-summary/confirmation-summary-participants/confirmation-summary-participants.component';
import { ConfirmationCseStockComponent } from './confirmation-cse-stock/confirmation-cse-stock.component';
import { ConfirmationMaterialStockDetailsExpandableComponent } from './confirmation-material-consume/confirmation-material-stock/confirmation-material-stock-details-expandable/confirmation-material-stock-details-expandable.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DateFieldComponent, TimeFieldComponent } from '@evorait/pace-components';
import { ClipboardModule } from 'ngx-clipboard';
import { LetDirective } from '@ngrx/component';
import { ConfirmationSummaryMeasurementToolsComponent } from './confirmation-summary/confirmation-summary-measurement-tools/confirmation-summary-measurement-tools.component';
import { ConfirmationFDA2579FormComponent } from './confirmation-FDA2579-form/confirmation-fda2579-form.component';
import { ConfirmationReasonMissingProtocolComponent } from './confirmation-reason-missing-protocol/confirmation-reason-missing-protocol.component';
import { ConfirmationSourceReplacementsComponent } from './confirmation-source-replacements/confirmation-source-replacements.component';
import { ConfirmationInstallationPaperworkComponent } from './confirmation-installation-paperwork/confirmation-installation-paperwork.component';
import { ConfirmationAppointmentComponent } from './confirmation-followup/appointment/confirmation-appointment.component';
import { AppointmentSlotRowComponent } from './confirmation-followup/appointment/appointment-slot-row.component';
import { ConfirmationMaterialStockDetailsComponent } from './confirmation-material-consume/confirmation-material-stock/confirmation-material-stock-details-expandable/confirmation-material-stock-details.component';

@NgModule({
    declarations: [
        ConfirmationComponent,
        ConfirmationExpensesComponent,
        ConfirmationSummaryComponent,
        ConfirmationMaterialConsumeComponent,
        ConfirmationFollowupComponent,
        ConfirmationServiceReportComponent,
        ConfirmationMeasurementToolsComponent,
        ConfirmationComplaintsP58Component,
        ConfirmationTimeRecordingComponent,
        ConfirmationEquipmentComponent,
        ConfirmationParticipantsComponent,
        ConfirmationSourceReplacementsComponent,
        ConfirmationMeasuringPointsComponent,
        ConfirmationMaterialGoodsInfoComponent,
        ConfirmationMaterialStockComponent,
        ConfirmationSummaryMaterialComponent,
        ConfirmationSummaryMeasurementToolsComponent,
        ConfirmationSummaryParticipantsComponent,
        ConfirmationAddMaterialComponent,
        AddTimeRecordingEntryFormComponent,
        MaterialConsumptionRowComponent,
        ConfirmationSignatureComponent,
        ConfirmationUploadToDocboxComponent,
        TimeSheetEntriesComponent,
        ConfirmationCseStockComponent,
        ConfirmationMaterialStockDetailsComponent,
        ConfirmationMaterialStockDetailsExpandableComponent,
        ConfirmationFDA2579FormComponent,
        ConfirmationReasonMissingProtocolComponent,
        ConfirmationInstallationPaperworkComponent,
        ConfirmationAppointmentComponent,
        AppointmentSlotRowComponent,
    ],
    exports: [ConfirmationComponent],
    imports: [
        CommonModule,
        ClipboardModule,
        LetDirective,
        SharedModule,
        FormsModule,
        DetailsModule,
        PaceCoreModule.forChild(),
        FontAwesomeModule,
        PaceCoreModule,
        DateFieldComponent,
        TimeFieldComponent,
    ],
})
export class ConfirmationModule {}
